import { FC, useMemo } from "react";
import { Stack } from "@mui/material";
import { UtilizationAndCoverageMultiTypeChartMetadata } from "./UtilizationAndCoverageMultiTypeChartMetadata";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { formatDateByFrequencyType } from "../../../../../../../../utils/helpers/date-time/datetime-format";
import { utilizationAndCoverageDateGranularitySelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/view-options/utilizationAndCoverageDateGranularitySelector";
import { savingsPlansGranularDataGroupedByDateSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/granular/savingsPlansGranularDataGroupedByDateSelector";
import { CommitmentsChart } from "../../../common/chart/CommitmentsChart";
import { utilizationAndCoverageChartTypeSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/view-options/utilizationAndCoverageChartTypeSelector";
import { commitmentsForGranularLoadingSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/loading/commitmentsForGranularLoadingSelector";
import { UtilizationAndCoverageDateGranularity } from "../../../options/UtilizationAndCoverageDateGranularity";
import { UtilizationAndCoverageChartTypeSelect } from "../../UtilizationAndCoverageChartTypeSelect";

export const UtilizationAndCoverageMultiTypeChart: FC = () => {
  const chartType = useAppSelector(utilizationAndCoverageChartTypeSelector);
  const loading = useAppSelector(commitmentsForGranularLoadingSelector);
  const dataPoint = useAppSelector(
    utilizationAndCoverageDateGranularitySelector,
  );
  const dataGroupedByDate = useAppSelector(
    savingsPlansGranularDataGroupedByDateSelector,
  );

  const chartProps = useMemo(() => {
    return {
      loading,
      dataGroupedByDate,
      labelFormatter: (value: string) =>
        formatDateByFrequencyType(dataPoint, value),
    };
  }, [dataPoint, dataGroupedByDate, loading]);

  if (chartType === "gauge") {
    return null;
  }

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="end"
        spacing={1}
      >
        <UtilizationAndCoverageDateGranularity />

        <UtilizationAndCoverageChartTypeSelect />
      </Stack>

      <UtilizationAndCoverageMultiTypeChartMetadata />

      {chartType === "bar" ? (
        <CommitmentsChart key="bar" availableTypes={["bar"]} {...chartProps} />
      ) : (
        <CommitmentsChart
          key="area"
          availableTypes={["area"]}
          {...chartProps}
        />
      )}
    </Stack>
  );
};
